import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import {
  PriceObjectOutputDto,
  ServiceProvisionUnitEnum,
} from '../../../../../../../lib/graphql'
import {
  decimalPrice,
  getPriceFromToggleStatus,
  roundedPrice,
} from '../../../../../../../utils'
import { divideByFactor } from '../../../../../../../utils/prices'
import VatLabel from '../../../../../../atoms/fields/vat-label/VatLabel'
import {
  useCurrencyAreaContext,
  usePriceContext,
} from '../../../../../../contexts'

interface ITagPriceProps {
  isApp?: boolean
  unit: ServiceProvisionUnitEnum
  priceObject: PriceObjectOutputDto | undefined
  hasRoundedPrice?: boolean
  isStartingFees?: boolean
  ownerFeesRate?: number
}

const getUnitLabel = (unit?: ServiceProvisionUnitEnum) => {
  switch (unit) {
    case ServiceProvisionUnitEnum.INDIVIDUAL:
      return (
        <>
          {' '}
          /{' '}
          <FormattedMessage
            id='ui.houseServices.tagPrice.person'
            defaultMessage='personne'
          />
        </>
      )

    case ServiceProvisionUnitEnum.GROUP:
      return (
        <>
          {' '}
          /{' '}
          <FormattedMessage
            id='ui.houseServices.tagPrice.prestation'
            defaultMessage='prestation'
          />
        </>
      )
    case ServiceProvisionUnitEnum.DAILY:
      return (
        <>
          {' '}
          /{' '}
          <FormattedMessage
            id='ui.houseServices.tagPrice.day'
            defaultMessage='jour'
          />
        </>
      )
    case ServiceProvisionUnitEnum.HALF_DAY:
      return (
        <>
          {' '}
          /{' '}
          <FormattedMessage
            id='ui.houseServices.tagPrice.halfDay'
            defaultMessage='demi-journée'
          />
        </>
      )
    case ServiceProvisionUnitEnum.NIGHT:
      return (
        <>
          {' '}
          /{' '}
          <FormattedMessage
            id='ui.houseServices.tagPrice.night'
            defaultMessage='nuit'
          />
        </>
      )
    default:
      return ''
  }
}

const TagPrice = ({
  isApp,
  priceObject,
  unit,
  hasRoundedPrice,
  isStartingFees,
  ownerFeesRate,
}: ITagPriceProps) => {
  const { currency } = useCurrencyAreaContext()
  if (!priceObject) {
    return null
  }

  const toggleStatus = usePriceContext()

  const price = getPriceFromToggleStatus({
    priceOption: priceObject,
    toggleStatus,
  })

  if (price !== 0 || !isApp || unit === ServiceProvisionUnitEnum.INCLUDED) {
    return (
      <div className={s.tagPrice}>
        <div>
          {isStartingFees && (
            <>
              <FormattedMessage
                id='ui.houseServices.tagPrice.startingFees'
                defaultMessage=' A partir de'
              />{' '}
            </>
          )}
          {hasRoundedPrice
            ? roundedPrice(price, { currency })
            : decimalPrice(price, { currency })}
          <VatLabel />
          {getUnitLabel(unit)}
        </div>
        {ownerFeesRate !== undefined && (
          <div className={s.ownerFeesRate}>
            {`${divideByFactor(ownerFeesRate)}%`}{' '}
            <FormattedMessage
              id='ui.houseServices.tagPrice.commission'
              defaultMessage='commission'
            />
          </div>
        )}
      </div>
    )
  } else {
    return null
  }
}

export default TagPrice
